import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Capacitor } from '@capacitor/core';
import { TranslateService } from '@ngx-translate/core';
import { ProfileService } from 'src/app/services/profile.service';
import { Profile } from 'src/app/shared/models/register.models';
import { Regions } from 'src/app/shared/other/regions';


@Component({
  selector: 'fun-register-person-address',
  templateUrl: './register-person-address.component.html',
  styleUrls: ['./register-person-address.component.scss']
})
export class RegisterPersonAddressComponent implements OnInit {

  @Output() public sendInfoEvent = new EventEmitter<any>();
  @Output() public sendErrorEvent = new EventEmitter<any>();
  @Output() public submitEvent = new EventEmitter<any>();
  @Input() public data;
  @Input() profile: Profile;
  @Input() towns: any;
  @Input() isMobile: boolean;

  public addressForm: UntypedFormGroup;
  public formControlKeys = [];
  public errorMessages = {};
  public isSubmit = false;
  public errorAmount = false;
  public errorConcept = false;
  public autocompleteMode = false;

  isNationalResidence: boolean;
  selectIsOpen = false;
  regionList = Regions.map(region => {
    return {
      id: region.code,
      name: region.name
    };
  });
  city: string;
  townList: any;
  taxRegion: any;

  desktopApp: boolean;

  @HostListener('document:keyup.enter', ['$event']) onKeyupEnterHandler(event: KeyboardEvent) {
    if (this.addressForm.valid) {
      this.sendInfoEvent.emit(this.addressForm.value);
      this.submitEvent.emit();
    } else {
      if ((event.target as Element).id === 'address') {
        document.getElementById('cp').focus();
      } else if ((event.target as Element).id === 'cp') {
        if (this.profile.taxCountry === 108) {
          document.getElementById('cp').blur();
        } else {
          document.getElementById('internationalRegion').focus();
        }
      } else if ((event.target as Element).id === 'internationalRegion') {
        document.getElementById('city').focus();
      }
      this.sendErrorEvent.emit();
      this.chdRef.detectChanges();
    }
  }

  constructor(
    public chdRef: ChangeDetectorRef,
    public translate: TranslateService,
    private profileService: ProfileService
  ) { }

  ngOnInit() {
    // Fix cuando no está definida la nacionalidad en los modal del perfil incompleto. Inicializamos los campos del data
    if (this.data !== undefined && this.data.residence !== null && this.data.residence !== undefined) {
      if (this.profile === null || this.profile === undefined) {
        this.profile = {
          taxCountry: this.data.residence,
          nationality: this.data.nation,
          taxAddress: null
        }
      } else {
        this.profile.taxCountry = this.data.residence;
        this.profile.nationality = this.data.nation;
        this.profile.taxAddress = null;
      }
    }
    this.isNationalResidence = (this.profile.taxCountry === null || this.profile.taxCountry === undefined || this.profile.taxCountry === 108) ? true : false;
    if (this.profile && this.profile !== undefined
      && (this.profile.taxCountry === 108 || this.profile.taxCountry === null || this.profile.taxCountry === undefined)) {
      if (this.profile.taxCity) {
        this.city = (this.profile.taxCity < 10) ? `0${this.profile.taxCity}` : this.profile.taxCity;
      }
      if (this.profile.taxRegion) {
        this.taxRegion = (this.profile.taxRegion < 10) ? `0${this.profile.taxRegion}` : this.profile.taxRegion.toString();
      }
      if (this.towns === null || this.towns === undefined) {
        this.towns = {
          list: []
        }
      } else {
        this.townList = this.towns.list !== null && this.towns.list !== undefined ? this.towns.list : [];
      }
      /* this.city = this.profile.taxCity; */
      if (this.isNationalResidence && (this.profile.taxAddress === null)) {
        this.autocompleteMode = true;
      }
    } else {
      this.autocompleteMode = (this.isNationalResidence) ? true : false;
      //this.isNationalResidence = false;
      this.city = this.profile !== null && this.profile !== undefined && this.profile.taxInternationalCity !== null ? this.profile.taxInternationalCity : '';
    }
    this.addressForm = new UntypedFormGroup({
      addressAutocomplete: new UntypedFormControl('', [Validators.pattern('^[A-Za-z-ñÑáéíóúÁÉÍÓÚóºòöôõøœōÓºÒÖÔÕØŒŌáàäâãåąæāÁªÀÄÂÃÅĄÆĀéèëêęėēíïìîįīÍÏÌÎĮĪúüùûūÚÜÙÛŪçÇ\' ,.0123456789ºª/]+$')]),
      address: new UntypedFormControl('', [Validators.required, Validators.pattern('^[A-Za-z-ñÑáéíóúÁÉÍÓÚóºòöôõøœōÓºÒÖÔÕØŒŌáàäâãåąæāÁªÀÄÂÃÅĄÆĀéèëêęėēíïìîįīÍÏÌÎĮĪúüùûūÚÜÙÛŪçÇ\' ,.0123456789ºª/]+$')]),
      cp: new UntypedFormControl('', [Validators.required, Validators.pattern('^[A-Za-z0123456789]+$')]),
      city: new UntypedFormControl(this.city ? this.city : null, [Validators.required]),
      region: new UntypedFormControl(this.taxRegion ? this.taxRegion : null, []),
      internationalRegion: new UntypedFormControl('', [Validators.pattern('^[A-Za-z-ñÑáéíóúÁÉÍÓÚóºòöôõøœōÓºÒÖÔÕØŒŌáàäâãåąæāÁªÀÄÂÃÅĄÆĀéèëêęėēíïìîįīÍÏÌÎĮĪúüùûūÚÜÙÛŪçÇ ]+$')])
    });
    this.formControlKeys = Object.keys(this.addressForm.controls);
    this.errorMessages = {
      // Durante el registro, "requerido" no debe mostrarse como error (solo bloquea continuar);
      // solo interesa avisar de problemas de formato mientras se rellena.
      required: '',
      pattern: this.translate.instant('input-errors-messages.format'),
    };
    // Fix cuando no está definida la nacionalidad. Por defecto, la tratamos como si fuera Spain
    if ((this.profile.taxCountry === 108) || (this.profile.taxCountry === null)) {
      this.addressForm.controls['cp'].setValidators([Validators.required, Validators.pattern('^[0123456789]+$')]);
      this.addressForm.controls['region'].setValidators([Validators.required]);
    } else {
      this.addressForm.controls['cp'].setValidators([Validators.required, Validators.pattern('^[A-Za-z0123456789]+$')]);
      this.addressForm.controls['city'].setValidators([Validators.required, Validators.pattern('^[A-Za-z-ñÑáéíóúÁÉÍÓÚóºòöôõøœōÓºÒÖÔÕØŒŌáàäâãåąæāÁªÀÄÂÃÅĄÆĀéèëêęėēíïìîįīÍÏÌÎĮĪúüùûūÚÜÙÛŪçÇ ]+$')]);
    }
    this.addressForm.controls['cp'].updateValueAndValidity();
    this.addressForm.controls['region'].updateValueAndValidity();
    this.addressForm.controls['city'].updateValueAndValidity();

    this.desktopApp = Capacitor.getPlatform() === 'web' ? true : false;
    // valueChanges cubre cualquier forma de modificar el valor (teclado, selects, autocompletado,
    // cortar/pegar) sin depender de qué evento DOM concreto disparó el cambio.
    this.addressForm.valueChanges.subscribe(() => {
      this.getInfo();
    });
    this.chdRef.detectChanges();
  }

  @HostListener('document:keyup', ['$event']) onKeyupHandler(event: KeyboardEvent) {
    this.getInfo();
    this.chdRef.detectChanges();
  }

  isFormComplete(): boolean {
    // Se leen los valores directamente (en vez de addressForm.valid) porque el status
    // cacheado del FormGroup puede no reflejar todavía el último cambio del usuario.
    const address = this.addressForm.get('address').value;
    const cp = this.addressForm.get('cp').value;
    const city = this.addressForm.get('city').value;
    if (!address || !cp || !city) {
      return false;
    }
    if (this.isNationalResidence) {
      if (!this.addressForm.get('region').value) {
        return false;
      }
    } else {
      if (!this.addressForm.get('internationalRegion').value) {
        return false;
      }
    }
    return this.addressForm.valid;
  }

  getInfo() {
    // Marca isSubmit para que fun-input muestre el error específico del campo con problemas.
    this.isSubmit = true;
    if (this.isFormComplete()) {
      this.sendInfoEvent.emit(this.addressForm.value);
    } else {
      this.sendErrorEvent.emit();
    }
    this.chdRef.detectChanges();
  }

  changeRegion(selected = '') {
    this.addressForm.controls['city'].setValue(null);
    // Fix cuando no está definida la nacionalidad. Inicializamos a Spain para el selector de regiones
    this.profile.taxCountry = 108;
    this.profileService.getCities(this.profile.taxCountry, this.addressForm.value.region).subscribe(resp => {
      this.townList = resp;
      this.chdRef.detectChanges();
      this.getInfo();
    });
  }

  changeRegionCity(region, city) {
    this.addressForm.controls['city'].setValue(null);
    // Fix cuando no está definida la nacionalidad. Inicializamos a Spain para el selector de regiones
    this.profile.taxCountry = 108;
    this.profileService.getCities(this.profile.taxCountry, region).subscribe(resp => {
      this.townList = resp;
      this.townList.forEach(town => {
        if (town.name.indexOf(city) === 0) {
          this.addressForm.controls['city'].setValue(town.id);
        }
      });
      this.chdRef.detectChanges();
      this.getInfo();
    });
  }

  switchAutocomplete(mode) {
    this.autocompleteMode = mode;
    this.chdRef.detectChanges();
  }

  getAddress(value) {
    this.autocompleteMode = false;
    this.chdRef.detectChanges();
    let numberAddress = '';
    let regionId = '';
    let cityName = '';
    value.address_components.forEach(element => {
      switch (element.types[0]) {
        case 'street_number': numberAddress = element.long_name;
          this.chdRef.detectChanges();
          break;

        case 'route':
        case 'town_square': const autoAddress = (numberAddress !== '') ? element.long_name + ', ' + numberAddress : element.long_name;
          this.addressForm.controls['address'].setValue(autoAddress);
          this.chdRef.detectChanges();
          break;

        case 'postal_code': this.addressForm.controls['cp'].setValue(element.long_name);
          this.chdRef.detectChanges();
          break;

        case 'administrative_area_level_2':
          this.regionList.forEach(region => {
            if (region.name.indexOf(element.long_name) > -1) {
              regionId = region.id;
              this.addressForm.controls['region'].setValue(regionId);
              this.chdRef.detectChanges();
            }
          });
          break;

        case 'locality': cityName = element.long_name;
          break;

      }
    });

    this.changeRegionCity(regionId, cityName);
  }

}
